import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import { quote } from "@universityofmaryland/web-icons-library/brand";
import { SMALL } from "../_constants.js";
const CreateQuoteIconElement = ({
  hasImage = false,
  isThemeMaryland,
  isTypeFeatured = false
}) => {
  const imageWithFeaturedLayout = hasImage && isTypeFeatured;
  const iconSpan = new ElementBuilder("span").withClassName("quote-icon-span").withStyles({
    element: {
      display: "block",
      position: "absolute",
      ...imageWithFeaturedLayout && {
        display: "none"
      },
      ...!hasImage && {
        height: "15px",
        width: "22px",
        left: "-24px",
        top: "-32px",
        [`@container (min-width: ${SMALL}px)`]: {
          left: `-${token.spacing["4xl"]}`,
          top: "0"
        }
      },
      ...hasImage && {
        bottom: "-7px",
        left: "-2px",
        height: "15px",
        width: "21px",
        [`@container (min-width: ${SMALL}px)`]: {
          height: "20px",
          width: "29px",
          top: "-11px",
          right: "-20px",
          left: "inherit"
        }
      },
      ["& svg"]: {
        fill: token.color.red,
        ...isThemeMaryland && {
          fill: token.color.gold
        }
      }
    }
  }).build();
  iconSpan.element.innerHTML = quote;
  return iconSpan;
};
const CreateQuoteStatementIconElement = ({
  isThemeGold
}) => {
  return new ElementBuilder().withClassName("statement-quote-icon").withStyles({
    element: {
      ["& svg"]: {
        fill: token.color.red,
        width: "24px",
        marginBottom: token.spacing.md,
        ...isThemeGold && {
          fill: token.color.gold
        }
      }
    }
  }).withHTML(quote).build();
};
const createCompositeQuoteIcon = CreateQuoteIconElement;
const createStatementQuoteIcon = CreateQuoteStatementIconElement;
export {
  createCompositeQuoteIcon,
  createStatementQuoteIcon
};
//# sourceMappingURL=icon.js.map
